module.exports = __webpack_public_path__ + "static/media/3.965d2d2a.jpeg";